import dayjs from 'dayjs';
import { toast } from 'components';

const BASE_URL = '/api';

export async function callApi(endpoint, method='GET', data=null, authenticated=true) {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }
  };
  if (data) {
    options.body = JSON.stringify(data);
  }

  try {
    if (authenticated) {
      const token = localStorage.getItem('token');
      if (token) {
        options.headers.Authorization = `Bearer ${token}`;
      } else {
        throw new Error("No token available!")
      }
    }

    const resp = await fetch(BASE_URL + endpoint, options);
    const result = await resp.json();
    if (!resp.ok) {
      throw new Error(result.message);
    }
    return result;
  } catch(ex) {
    toast(`Error call api: ${ex.message || ex}`, 'error')
    throw ex;
  }
}

export function sanitizeDownloadBasename(basename) {
  const sanitized = String(basename || 'download')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
  return sanitized || 'download';
}

export function download(url, basename) {
  // https://stackoverflow.com/questions/695151/data-protocol-url-size-limitations
  callApi(url)
    .then(resp => fetch(`data:application/octet-stream;base64,${resp.b64}`))  // base64 to blob
    .then(resp => resp.blob())
    .then(blob => {
      const fn = sanitizeDownloadBasename(basename) + '-' + dayjs().tz().format('MMDD_HHmmss') + '.xlsx';
      // create blob link to download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', fn);
      document.body.appendChild(a);
      a.click();
      setTimeout(() => { a.parentNode.removeChild(a); window.URL.revokeObjectURL(url); }, 200);
    })
    .catch(console.error);
}
